import "../../../resources/less/Family/ThemePages/FairyTales.less";
import BaseThematique from "./BaseThematique";

class FairyTales extends BaseThematique   {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new FairyTales();
});
